import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiArrowUpRight, FiPlus, FiCheck } from 'react-icons/fi';
import { useCart } from '../context/CartContext';

const ProductCard = ({ product, index }) => {
  const { addToCart } = useCart();
  const [isAdding, setIsAdding] = useState(false);

  const handleAdd = () => {
    setIsAdding(true);
    setTimeout(() => {
      addToCart(product);
      setIsAdding(false);
    }, 600);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      className="group relative"
    >
      <div className="relative aspect-[3/4] overflow-hidden rounded-2xl bg-zinc-900 border border-white/5 focus-within:ring-2 focus-within:ring-fuchsia-500 outline-none">
        {/* Hover Overlay */}
        <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-all duration-500 z-20 backdrop-blur-[2px] flex flex-col justify-end p-6">
          <div className="translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
            <p className="text-zinc-300 text-xs mb-4 leading-relaxed line-clamp-2">
              {product.description}
            </p>
            <div className="flex flex-wrap gap-2 mb-6">
              {product.specs?.map(spec => (
                <span key={spec} className="text-[9px] font-bold uppercase tracking-tighter bg-white/10 px-2 py-0.5 rounded">
                  {spec}
                </span>
              ))}
            </div>
            <button 
              onClick={handleAdd}
              disabled={isAdding}
              className={`w-full h-12 flex items-center justify-center gap-2 font-black uppercase tracking-widest text-[10px] transition-all
                ${isAdding ? 'bg-cyan-400 text-black' : 'bg-white text-black hover:bg-fuchsia-500 hover:text-white'}`}
            >
              <SafeIcon icon={isAdding ? FiCheck : FiPlus} className={isAdding ? 'animate-bounce' : ''} />
              {isAdding ? 'Logged' : 'Add to Cart'}
            </button>
          </div>
        </div>

        {product.tag && (
          <div className="absolute top-4 left-4 z-10 bg-white/10 backdrop-blur-md border border-white/10 px-3 py-1 rounded-full">
            <span className="text-[9px] font-black uppercase tracking-widest text-white">
              {product.tag}
            </span>
          </div>
        )}

        <img 
          src={product.image} 
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-110"
          loading="lazy"
        />
        
        <div className="absolute top-4 right-4 z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center text-black">
            <SafeIcon icon={FiArrowUpRight} />
          </div>
        </div>
      </div>

      <div className="mt-6 flex justify-between items-end">
        <div>
          <p className="text-[10px] font-black uppercase tracking-[0.2em] text-fuchsia-500 mb-1">
            {product.device}
          </p>
          <h3 className="text-xl font-black uppercase tracking-tighter text-white">
            {product.name}
          </h3>
        </div>
        <div className="text-right">
          <p className="text-lg font-black font-mono text-zinc-400">${product.price}</p>
        </div>
      </div>
    </motion.div>
  );
};

export default ProductCard;